import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { TestService } from 'src/app/_services/test.service';
import _ from "lodash";
import { UrlService } from 'src/app/_services/url.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SpinnerService } from 'src/app/_services/spinner.service';
import { MemoryService } from 'src/app/_services/memory.service';

@Component({
  selector: 'app-test-suite',
  templateUrl: './test-suite.component.html',
  styleUrls: ['./test-suite.component.scss']
})
export class TestSuiteComponent implements OnInit {

  //DOM references down below
  @ViewChild("cancelUpdateSuite") cancelUpdateSuite: ElementRef;
  @ViewChild("cancelAddTestSuite") cancelAddTestSuite: ElementRef;
  @ViewChild("cancelAssociationModal") cancelAssociationModal: ElementRef;
  @ViewChild("cancelImportSelenium") cancelImportSelenium: ElementRef;
  @ViewChild("cancelImportTestCase") cancelImportTestCase: ElementRef;
  @ViewChild("cancelAddTestCase") cancelAddTestCase: ElementRef;
  @ViewChild("cancelCopySuite") cancelCopySuite: ElementRef;
  
  //global variables down below
  // importSeleniumForm:FormGroup;
  // addImportTestCaseForm:FormGroup;
  suiteRenameForm: UntypedFormGroup;
  addTestSuiteForm: UntypedFormGroup;
  addTestCaseForm: UntypedFormGroup;

  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Suite',
    data: undefined,
  }
  regexStr = '^[a-zA-Z0-9_{}[]() ]+$'
  projectId: string = "";
  moduleId: string = "";
  projectData: any;
  moduleData: any;
  moduleName: any;
  testSuiteData: any;
  selectedPage: any;
  selectedModule: any;
  selectedTestSuite: any;
  pagesSize=beatBlipSubscriptionConsts.pagesSize;
  perpageitem =beatBlipSubscriptionConsts.perpageitem;
  compareName: any;
  textData: any;
  testDataForAssociation: any;
  associationButton: any;
  disassociationButton: any;
  manageSuiteData: any;
  searchTestData: string;
  activeState: any;
  seleniumFileName: string;
  enableseleniumButton: boolean;
  seleniumFile: any;
  testDataFile: any;
  testDataFileName: any;
  importedTestCase: any;
  enableManual: boolean = false;
  searchModule: any;
  previousUrl: any=[];
  currentUrl: any;
  previousUrltemp: any;
  urlName: string;
  projectSubscription: Subscription;
  enableTopNav: boolean=false;
  breadCrumb: any;
  agentCheck: boolean;
  readOnlyCheck: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private testService: TestService,
    private formBuilder: UntypedFormBuilder,
    private router:Router,
    private urlService:UrlService,
    private testCase: TestService,
    private spinnerService : SpinnerService,
    private memoryService:MemoryService,
    private confirmationDialogService: ConfirmationDialogService,
    private toastrService: ToastrService) { }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe(
      (response)=>{
        this.agentCheck = response;
       
      }
    )
    this.initAllForms();
    this.testCase.setView(true)
    // this.spinnerService.isLoading.next(false);
    this.activatedRoute.paramMap.subscribe((params) => {
      this.projectId = params.get("pid");
      this.moduleId =  params.get("mid");
      localStorage.setItem('moduleId',this.moduleId);
      setTimeout(() => {
        this.enableTopNav = true
      }, 0);
      if(!this.agentCheck){
      // this.projectSubscription = this.projectService.getProjectDetails().subscribe((res)=>
      if(JSON.parse(localStorage.getItem('projectDataById'))){
        var res = JSON.parse(localStorage.getItem('projectDataById'));
        this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
        this.headerOptions.data = { 
          projectId : this.projectId,
          projectName: res['projectName']
        };

        this.projectData = res;
        this.loadSuites();
      // });
      }
    }
    else if(this.agentCheck){
this.projectSubscription = this.projectService.getProjectDetails().subscribe(
  (res)=>{
     this.projectData = res;
// if(JSON.parse(localStorage.getItem('projectDataById'))){
  // var res = JSON.parse(localStorage.getItem('projectDataById'));
 
  // this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
  this.headerOptions.data = { 
    projectId : this.projectId,
    projectName: res['projectName']
  };
  this.memoryService.getBreadCrumb().subscribe(
    (breadCrumb)=>{
      this.breadCrumb = breadCrumb;
    }
  )
  this.loadSuites();
});

    }
      else if(!JSON.parse(localStorage.getItem('projectDataById')))
      {
        this.projectService.getProjectById(this.projectId).subscribe((res) => {
          this.headerOptions.data = { 
            projectId : this.projectId,
            projectName: res['projectName']
          };
          this.projectData = res;
          this.loadSuites();
        });
      }
      
    });

    
  }

  initAllForms()
  {
    this.suiteRenameForm = this.formBuilder.group({
      suiteName: [ "",[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      adoIntId: ["", [Validators.required]],
      comment: [""],
      dependent: [false],
    });

    this.addTestSuiteForm = this.formBuilder.group({
      suiteName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      adoIntId: ["", [Validators.required]],
      comment: [""],
      dependent: [false],
    });

    this.addTestCaseForm = this.formBuilder.group({
      title: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      testCaseId: [""],
      dataLabels: [""],
      comment: [""],
      executionIteration: [1, Validators.required],
    });
  }

  loadSuites() {
    if (JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))) {
      var res = JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))
      console.log('tests', res);

      this.moduleData = res["testSuiteDirData"]
        ? res["testSuiteDirData"].map((data) => { data['type'] = 'module'; return data })
        : undefined;
      let suiteData = res["testSuiteFileData"]
        ? res["testSuiteFileData"]
        : undefined;

      this.testSuiteData = suiteData ? suiteData.filter((data) => data.path != ",").filter((data) => data.parentTestDataId == this.moduleId) : undefined;
      this.moduleName = this.moduleData.find((data) => data.id == this.moduleId).title;
      this.currentUrl = this.router.url;
      this.urlName = this.moduleName;
      this.previousUrl = this.urlService.captureUrl(this.currentUrl, this.urlName, 'testSuite');
      if (!this.agentCheck) {
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
      else {
        this.memoryService.setUrlHistory(this.previousUrl);
        this.memoryService.getUrlHistory().subscribe(
          (urlHistory) => {
            this.previousUrl = urlHistory;
          }
        )
      }
      // });
    }
    if (!JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))) {
      this.testService.getAllChildTestDir(this.projectId).subscribe((resp) => {
        try {
          if(!this.agentCheck){
            localStorage.setItem('getAllChildTestDirResPonse', JSON.stringify(resp));
          }
          this.moduleData = resp["testSuiteDirData"]
            ? resp["testSuiteDirData"].map((data) => { data['type'] = 'module'; return data })
            : undefined;
          let suiteData = resp["testSuiteFileData"]
            ? resp["testSuiteFileData"]
            : undefined;

          this.testSuiteData = suiteData ? suiteData.filter((data) => data.path != ",").filter((data) => data.parentTestDataId == this.moduleId) : undefined;
          this.moduleName = this.moduleData.find((data) => data.id == this.moduleId).title;
          this.currentUrl = this.router.url;
          this.urlName = this.moduleName;
          this.previousUrl = this.urlService.captureUrl(this.currentUrl, this.urlName, 'testSuite');
          if (!this.agentCheck) {
            localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
            this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
          }
          else {
            this.memoryService.setUrlHistory(this.previousUrl);
            this.memoryService.getUrlHistory().subscribe(
              (urlHistory) => {
                this.previousUrl = urlHistory;
              }
            )
          }
        } catch (error) {
          // localStorage.setItem('getAllChildTestDirResPonse',JSON.stringify(resp));
          console.log('tests', resp);

          this.moduleData = resp["testSuiteDirData"]
            ? resp["testSuiteDirData"].map((data) => { data['type'] = 'module'; return data })
            : undefined;
          let suiteData = resp["testSuiteFileData"]
            ? resp["testSuiteFileData"]
            : undefined;

          this.testSuiteData = suiteData ? suiteData.filter((data) => data.path != ",").filter((data) => data.parentTestDataId == this.moduleId) : undefined;
          this.moduleName = this.moduleData.find((data) => data.id == this.moduleId).title;
          this.currentUrl = this.router.url;
          this.urlName = this.moduleName;
          this.previousUrl = this.urlService.captureUrl(this.currentUrl, this.urlName, 'testSuite');
          localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
          this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
        }

      });
    }
  }

  addTestSuite() {
    if (this.addTestSuiteForm.invalid) {
      return;
    }
    var formValue = this.addTestSuiteForm.value;

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.suiteName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }

    let ValueForAdd = {
      title: formValue.suiteName,
      comment: formValue.comment,
      dependent: formValue.dependent,
      parentTestDataId: this.moduleId,
      projectId: this.projectId,
      adoIntId: formValue.adoIntId
    };

    this.projectService.addTestSuite(ValueForAdd).subscribe((res) => {
      if (res) {
        localStorage.removeItem('getAllChildTestDirResPonse')
        this.toastrService.clear();
        this.toastrService.success("Suite Added successfully");
        this.cancelAddTestSuite.nativeElement.click();
        this.loadSuites();
      }
    });
  }

  deleteTestSuite(suite)
  {
    console.log(suite);
    this.confirmationDialogService
    .openConfirmDialog(
      "Are you sure to delete " + suite.title + " ?"
    )
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.projectService
        .deleteModule(this.projectId, suite.id)
        .subscribe((res) => {
          this.toastrService.clear();
          this.toastrService.success("Suite deleted successfully");
          localStorage.removeItem('getAllChildTestDirResPonse');
          this.loadSuites();
        });
      }
    });
  }

  openUpdateSuite(suite) {
    this.selectedTestSuite = suite;
    this.readOnlyCheck = suite?.adoIntId
    this.suiteRenameForm.patchValue({
      suiteName: suite.title,
      comment: suite.comment,
      dependent: suite.dependent == "true" ? true : false,
    });
  }

  updateSuite() {
    if (this.suiteRenameForm.invalid) {
      return;
    }
    let formValue = this.suiteRenameForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(formValue.suiteName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    let valueForUpdate = {
      title: formValue.suiteName,
      comment: formValue.comment,
      projectId: this.selectedTestSuite.projectId,
      id: this.selectedTestSuite.id,
      dependent: formValue.dependent,
      parentTestDataId: this.selectedTestSuite.parentTestDataId,
      adoIntId: formValue.adoIntId
    };

    this.testService.editTestFile(valueForUpdate).subscribe((data) => {
      this.cancelUpdateSuite.nativeElement.click();
      localStorage.removeItem('getAllChildTestDirResPonse');
      this.loadSuites();
      this.projectService.sendUpdateData(data);
      this.toastrService.success("Suite updated successfully");
    });
  }

  onPageChange(newValue){
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }

  restoreSuiteData(suite) {
    let projectId = suite.projectId;
    let suiteId = suite.id;
    let arrayData = [];
    this.projectService
      .restoreSuite(projectId, suiteId, arrayData)
      .subscribe((data) => {
        localStorage.removeItem('getAllChildTestDirResPonse');
        this.loadSuites();
        this.toastrService.clear();
        this.toastrService.success('Restored Successfully')
      });
  }

  association(item) {
    this.searchTestData = "";
    this.compareName = "";
    this.projectService.getDefaultTextData(this.projectId).subscribe((data) => {
      this.textData = data["textData"];
      this.testDataForAssociation = this.textData.filter(
        (f) => f.name == item.testDataSourceName.name
      );
      if (this.testDataForAssociation.length > 0) {
        this.compareName = this.testDataForAssociation[0].name;
        this.associationButton = true;
      } else {
        this.compareName = "";
      }
      if (this.compareName.length > 2) {
        this.disassociationButton = false;
      } else {
        this.disassociationButton = true;
      }
    });

    this.testService.getSuitData(this.projectId, item.id).subscribe((data) => {
      this.manageSuiteData = data;
    });
  }

  associateData(name, settingName) {
    if (this.compareName == name) {
      this.activeState = name;
      this.disassociationButton = false;
      this.associationButton = true;
    } else if (this.compareName != name) {
      this.activeState = name;
      this.associationButton = false;
      this.disassociationButton = true;
    }

    var obj = {
      name: name,
      settingName: settingName,
    };
    this.manageSuiteData.testDataSourceName = obj;
  }

  disassociate() {
    this.testDataForAssociation;
    var obj = {
      name: this.testDataForAssociation[0].name,
      settingName: this.testDataForAssociation[0].settingName,
    };
    delete this.manageSuiteData.testDataSourceName;
    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        this.toastrService.success("Entity Updated Successfully");
        this.cancelAssociationModal.nativeElement.click();
        localStorage.removeItem('getAllChildTestDirResPonse')
        this.loadSuites();
      });
  }

  submitAssoiciatedData() {
    this.manageSuiteData = _.omit(this.manageSuiteData, [
      "testCaseData",
      "dynamicTestResult",
      "active",
      "execuationIteration",
      "executionCount",
      "path",
      "runState",
      "selectedState",
      "content",
    ]);

    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        this.toastrService.clear();
        this.toastrService.success("Entity Updated Successfully");
        this.cancelAssociationModal.nativeElement.click();
        localStorage.removeItem('getAllChildTestDirResPonse');
        this.loadSuites();
      });
  }

  resetSeleniumModel() {
    this.seleniumFileName = "";
    this.seleniumFile = File;
    this.enableseleniumButton = false;
  }

  uploadSeleniumData(event: any) {
    this.resetSeleniumModel();
    this.enableseleniumButton = true;
    this.seleniumFile = event.target.files[0];
    this.seleniumFileName = this.seleniumFile.name.substring(
      0,
      this.seleniumFile.name.lastIndexOf(".")
    );
  }

  onImportSeleniumFile() {
    if (this.seleniumFile == undefined) {
      return;
    }
    var fd = new FormData();
    fd.append("file", this.seleniumFile);
    this.projectService
      .uploadSelenium(this.projectId, this.selectedTestSuite.id, fd)
      .subscribe((res) => {
        this.seleniumFileName = "";
        localStorage.removeItem('getAllChildTestDirResPonse');
        this.loadSuites();
        this.toastrService.success("Recorded file uploaded successfully");
        this.cancelImportSelenium.nativeElement.click();
        this.projectService.sendUpdateData(res);
        this.resetSeleniumModel();
      });
  }

  onImportTestCase() {
    {
      if (this.testDataFile == undefined) {
        return;
      }
      var fd = new FormData();
      fd.append("file", this.testDataFile);
      this.projectService.uploadTestCase(this.projectId, this.selectedTestSuite.id, fd).subscribe((res) => {
        this.cancelImportTestCase.nativeElement.click();
        this.importedTestCase = res["testCaseData"];
        if (this.importedTestCase) {
          var testCaseName = [];
          var showToaster = false;
          var counter = 1;
          localStorage.removeItem('getAllChildTestDirResPonse');
          this.loadSuites();
          var toastrMsg = "<h5>Following Cases are imported : <h5> <br/>";
          for (let i = 0; i < this.importedTestCase.length; i++) {
            toastrMsg +=
              counter++ + ". " + this.importedTestCase[i].title + "<br/>";
            showToaster = true;
          }
          if (showToaster) {
            this.toastrService.clear();
            this.toastrService.info(toastrMsg, null, {
              enableHtml: true,
              tapToDismiss: false,
            });
          }
          this.projectService.sendTestData(this.importedTestCase);
        } else {
          this.toastrService.clear();
          this.toastrService.warning("Selected Case file already exist");
        }
      });
    }
  }

  uploadTestCase(event: any) {
    this.testDataFile = event.target.files[0];
    this.testDataFileName = this.testDataFile.name;
  }

  resetTestDataModel() {
    this.testDataFileName = "";
    this.testDataFile = undefined;
  }

  onCreateTestCase() {
    if (this.addTestCaseForm.invalid) {
      return;
    }

    var objFormval = this.addTestCaseForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(this.addTestCaseForm.value.title)) {
     this.toastrService.clear();
     this.toastrService.warning(
       'Case name is not Valid, Name can not contain /[<>:"/\\|?*'
     );
     return;
   }

    var objFormval = this.addTestCaseForm.value;
    if (this.enableManual) {
      objFormval.testCaseType = "MANUAL";
    }

    this.testService
      .addTestCase(this.projectId, this.selectedTestSuite.id, objFormval)
      .subscribe((data) => {
        this.projectService.sendUpdateData(data);
        localStorage.removeItem('getAllChildTestDirResPonse');
        this.loadSuites();
        this.cancelAddTestCase.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success(" New Case Added successfully");
      });
  }

  captureTestSuiteForPaste(module)
  {
    this.selectedModule = module;
  }

  pasteTestCase() {
    this.testService
      .pasteSuite(
        this.projectId,
        this.selectedModule.id,
        this.selectedTestSuite.id
      )
      .subscribe((data) => {
        this.toastrService.clear();
        this.toastrService.success("Suite pasted successfully");
        this.cancelCopySuite.nativeElement.click();
        this.projectService.subjectforTestSuite.next(null);
        localStorage.removeItem('getAllChildTestDirResPonse');
        this.loadSuites();
      });
  }

  clearTag()
  {
    this.addTestCaseForm.patchValue({
      dataLabels: ""
    });
  }

}
